/**
 * Created by wwei on 2017-06-29.
 */
import React, { Component } from "react";
import { Spin, Icon } from "antd";

class Loading extends Component {
  render = () => {
    const { tip, size } = this.props;
    let fontSize = 24;
    switch (size) {
      case "small":
        fontSize = 16;
        break;
      case "large":
        fontSize = 36;
        break;
      default:
        break;
    }
    const antIcon = (
      <Icon
        type="loading-3-quarters"
        style={{ fontSize: fontSize, color: "#0277BD" }}
        spin
      />
    );
    return <Spin indicator={antIcon} tip={tip} />;
  };
}

export default Loading;



// WEBPACK FOOTER //
// ./src/common/components/Loading.js